import { useRef, useState } from "react";
import { Upload, File as FileIcon, X } from "lucide-react";
import { cn } from "@/lib/utils";

const ACCEPT = ".pdf,.docx,.jpg,.jpeg,.png,.webp,.txt";

export default function UploadZone({ value, onChange, accent = "#002FA7" }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  function handleFiles(files) {
    if (!files || files.length === 0) return;
    onChange(files[0]);
  }

  return (
    <div>
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragOver(false);
          handleFiles(e.dataTransfer.files);
        }}
        onClick={() => inputRef.current?.click()}
        className={cn(
          "cursor-pointer rounded-2xl border-2 border-dashed bg-white p-10 text-center transition-all",
          dragOver ? "border-[var(--up-accent)] bg-blue-50/40" : "border-border hover:border-ink-soft"
        )}
        style={{ "--up-accent": accent }}
        data-testid="upload-zone"
      >
        <input
          ref={inputRef}
          type="file"
          accept={ACCEPT}
          className="hidden"
          onChange={(e) => handleFiles(e.target.files)}
          data-testid="upload-input"
        />

        {!value ? (
          <div className="flex flex-col items-center gap-3">
            <div
              className="h-14 w-14 rounded-2xl flex items-center justify-center text-white shadow-sm"
              style={{ background: accent }}
            >
              <Upload className="h-7 w-7" />
            </div>
            <p className="font-display text-lg font-semibold text-ink">
              Sleep je document hier, of klik om te uploaden
            </p>
            <p className="text-sm text-ink-soft">
              PDF, Word (.docx), foto (JPG/PNG/WEBP) of tekstbestand — max 15 MB
            </p>
            <p className="text-xs text-ink-soft mt-2">
              Versleuteld geüpload · Automatisch verwijderd na 30 dagen
            </p>
          </div>
        ) : (
          <div className="flex items-center gap-4 justify-center">
            <div className="h-12 w-12 rounded-xl bg-slate-100 flex items-center justify-center text-ink">
              <FileIcon className="h-6 w-6" />
            </div>
            <div className="text-left">
              <p className="font-semibold text-ink truncate max-w-xs" data-testid="upload-filename">
                {value.name}
              </p>
              <p className="text-xs text-ink-soft">
                {(value.size / 1024).toFixed(1)} KB
              </p>
            </div>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onChange(null);
              }}
              className="p-2 rounded-full hover:bg-slate-100"
              data-testid="upload-clear"
              aria-label="Verwijder bestand"
            >
              <X className="h-4 w-4 text-ink-soft" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
